import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ClientDocumentsResolverService {
  constructor(private http: HttpClient) { }

  resolve(route: ActivatedRoute): Observable<string[]> {

    if (route.params['client']) {
      const params = new HttpParams().set('client', route.params['client']);
      return this.http.get<string[]>(environment.baseUrl + 'weedfree/documents/list', { params: params });
    } else {
      return this.http.get<string[]>(environment.baseUrl + 'client/documents');
    }

  }
}
